export default __webpack_public_path__ + "static/media/fenerbahce.43fdb1fd.svg";